import React, {useState} from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../ui/Dialog/DialogActions";
import Button from "../../../../../../ui/Button";
import KuratorEditForm from "../KuratorEditForm";

const styles = theme => ({
  dialog: {
    width: "550px"
  }
});

const KuratorEditModal = ({
  open,
  handleClose,
  classes,
  orgId,
  curatorId,
  updateProfile
}) => {
  const [formData, updateFormData] = useState(null);

  const onConfirm = () => {
    updateProfile(orgId,formData);
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Выбрать куратора организации</DialogTitle>
        <DialogContent>
          <KuratorEditForm orgId={orgId}
                          curatorId={curatorId}
                          onFormChange={updateFormData}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            //loading={isCreatingRoom}
            disabled={!formData || !formData.personId || formData.personId===-1}
            onClick={() => onConfirm()}
            color="green"
          >
            Сохранить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(withRouter(KuratorEditModal));
